import BaseService from "../base-service";
import NetworkUrls from "../network-urls";

class TermTextService extends BaseService {

  async fetch (lang) {

    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!) {
            TermLegal {
                many (lang: $lang) {title, content}
            },
            TermOfSales {
                many (lang: $lang) {title, content}
            }
        }`,
        variables: {lang}
      }
    }

    return this._exec(config);

  }

}

export const termTextService = new TermTextService();



// WEBPACK FOOTER //
// ./src/network/services/term-text.service.js